import React from "react";
import { motion } from "framer-motion";
import { HiLocationMarker, HiPhone, HiMail, HiClock } from "react-icons/hi";

const CONTACT_INFO = [
  {
    icon: HiLocationMarker,
    title: "Visit Us",
    lines: ["The Pahadi Bistro","Shop No.2, Global Highstreet", "Global Precioso Rd, near EON Free Zone", "Kharadi, Pune 411014"],
    href: "https://maps.app.goo.gl/pFED83LLDGAwdcBk6",
    linkLabel: "Get Directions",
  },
  {
    icon: HiPhone,
    title: "Call Us",
    lines: ["+91 93733 09484"],
    href: "tel:+919373309484",
    linkLabel: "Call Now",
  },
  {
    icon: HiMail,
    title: "Email Us",
    lines: ["thepahadibistro@gmail.com"],
    href: "mailto:thepahadibistro@gmail.com",
    linkLabel: "Send Email",
  },
  {
    icon: HiClock,
    title: "Hours",
    lines: [
      "Mon · Wed · Thu — 12 – 10 PM",
      "Fri · Sat · Sun — 12 – 11 PM",
      "Break — 4 – 5 PM",
      "Tue — Closed",
    ],
    href: null,
    linkLabel: null,
  },
];

function FadeInUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export default function Contact() {
  return (
    <section id="contact" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="section-heading">Get In Touch</h2>
          <div className="accent-divider" />
          <p className="section-subheading">We'd love to see you. Visit us or reach out anytime.</p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
          {/* Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {CONTACT_INFO.map((info, i) => (
              <FadeInUp key={info.title} delay={i * 0.1}>
                <div className="bg-cream rounded-2xl p-6 h-full border border-gray-100 hover:shadow-md transition-shadow duration-200">
                  <div className="w-12 h-12 rounded-xl bg-redAccent/10 flex items-center justify-center mb-4">
                    <info.icon className="w-6 h-6 text-redAccent" />
                  </div>
                  <h3 className="font-display font-semibold text-lg text-black mb-2">{info.title}</h3>
                  {info.lines.map((line, idx) => (
                    <p key={idx} className="text-gray-600 text-sm leading-relaxed">{line}</p>
                  ))}
                  {info.href && (
                    <a
                      href={info.href}
                      target={info.href.startsWith("http") ? "_blank" : undefined}
                      rel={info.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      className="inline-block mt-3 text-sm font-semibold text-redAccent hover:text-redDark transition-colors underline underline-offset-2"
                    >
                      {info.linkLabel} &rarr;
                    </a>
                  )}
                </div>
              </FadeInUp>
            ))}
          </div>

          {/* Map */}
          <FadeInUp delay={0.2}>
            <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-100 h-full min-h-[350px]">
              <iframe
                title="The Pahadi Bistro location on Google Maps"
                className="w-full h-full min-h-[350px]"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.3762508705854!2d73.9493003748465!3d18.557068482543528!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c346f10ba31b%3A0xec8285cbe66a71e7!2sThe%20Pahadi%20Bistro!5e0!3m2!1sen!2sca!4v1770590281164!5m2!1sen!2sca"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>
  );
}
